import {
  LOADING_UPDATE_TRANSACTION,
  LOADING_GET_TRANSACTIONS,
  GET_TRANSACTIONS,
  SET_TRANSACTION,
} from "../types";

const INITIAL_STATE = {
  transactions: [],
  transaction: {},
  loadingGetTransactions: false,
  loadingUpdateTransaction: false,
};

const transactionsReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case GET_TRANSACTIONS:
      return { ...state, transactions: action.payload };
    case SET_TRANSACTION:
      return { ...state, transaction: action.payload };
    case LOADING_GET_TRANSACTIONS:
      return { ...state, loadingGetTransactions: action.payload };
    case LOADING_UPDATE_TRANSACTION:
      return { ...state, loadingUpdateTransaction: action.payload };

    default:
      return state;
  }
};

export default transactionsReducer;
